// src/public-routes/sectors/SectorsPage.jsx
import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
    FaShoppingBag,
    FaHotel,
    FaPlane,
    FaBuilding,
    FaChartLine,
    FaCloud,
    FaCreditCard,
    FaGlobe
} from 'react-icons/fa';


const SectorsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sectors = [
        {
            id: 'ecommerce',
            title: 'Ecommerce',
            description: 'Scale profitably through data-driven campaigns & CRO',
            icon: FaShoppingBag,
            path: '/sectors/ecommerce'
        },
        {
            id: 'hospitality',
            title: 'Hospitality',
            description: 'Increase direct bookings & brand visibility',
            icon: FaHotel,
            path: '/sectors/hospitality'
        },
        {
            id: 'saas',
            title: 'SaaS',
            description: 'Growth marketing across the full funnel',
            icon: FaCloud,
            path: '/sectors/sass'
        },
        {
            id: 'travel',
            title: 'Travel',
            description: 'Demand generation across paid & organic channels',
            icon: FaPlane,
            path: '/sectors/travel'
        },
        {
            id: 'b2b',
            title: 'B2B',
            description: 'Lead generation & pipeline growth',
            icon: FaBuilding,
            path: '/sectors/b2b'
        },
        {
            id: 'finance',
            title: 'Finance',
            description: 'Trust-led marketing with compliance awareness',
            icon: FaChartLine,
            path: '/sectors/finance'
        },
        {
            id: 'fintech',
            title: 'Fintech',
            description: 'Performance, trust & scale in competitive markets',
            icon: FaCreditCard,
            path: '/sectors/fintech'
        },
        {
            id: 'all-sectors',
            title: 'All Sectors',
            description: 'Tailored strategies for every business type',
            icon: FaGlobe,
            path: '/sectors/all-sectors'
        }
    ];

    return (
        <div className="sectors-page">
            {/* Full Width Banner with Text Overlay */}
            <div
                className="sectors-hero-banner"

            >
                <Container>
                    <div className="sectors-hero-content">
                        <h1 className="sectors-hero-title">
                            Sector-Focused Digital Marketing,{' '}
                            <span>Built for Impact</span>
                        </h1>
                        <p className="sectors-hero-subtitle">
                            High-performance digital marketing strategies tailored to the unique dynamics of each sector.
                            We combine strategic thinking, data intelligence, and advanced tools to create campaigns
                            that perform and differentiate your brand.
                        </p>
                        <div className="sectors-hero-cta">
                            <Button tag={Link} to="/contact" color="dark" size="lg">
                                Get Started
                            </Button>
                            <Button tag={Link} to="/contact" color="primary" size="lg">
                                Book Consultation
                            </Button>
                        </div>
                    </div>
                </Container>
            </div>

            {/* Sectors Grid */}
            <div className="sectors-grid-section">
                <Container>
                    <div className="sectors-grid-intro">
                        <h2>
                            Our <span>Capabilities</span> Across Key Sectors
                        </h2>
                        <p>
                            Rather than applying generic solutions, we take the time to understand the nuances
                            of your market, audience, and competitive landscape. Our approach combines strategic
                            thinking, data intelligence, and advanced tools to create campaigns that perform
                            and differentiate your brand.
                        </p>
                    </div>

                    <Row className="justify-content-center">
                        {sectors.map((sector, index) => (
                            <Col xs={6} sm={4} md={4} lg={3} key={index} className="mb-3">
                                <Link to={sector.path} className="sector-mini-card">
                                    <div className="sector-mini-icon">
                                        <sector.icon />
                                    </div>
                                    <h4>{sector.title}</h4>
                                    <p className="sector-mini-desc">{sector.description}</p>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            {/* Bottom CTA */}
            <div className="sectors-bottom-cta">
                <Container>
                    <h2>Beyond Sectors</h2>
                    <p>
                        While we bring strong experience across these industries, our expertise is not limited to them.
                        Every business is unique — and so is our approach. If you operate in a different sector,
                        we'd love to hear from you.
                    </p>
                    <Button tag={Link} to="/contact" color="dark" size="lg">
                        Get In Touch
                    </Button>
                </Container>
            </div>
        </div>
    );
};

export default SectorsPage;